import React, { useEffect, useState } from "react";
import { uploadIcon } from "../../components/images";
import { MDBIcon } from "mdb-react-ui-kit";
import { downloadBrandProofDoc } from "../../apiclients/streamsapi_bridge";
import UIConstant from "../../apiclients/UIConstant";

const ProofDocuments = ({
  register,
  watch,
  errors,
  setValue,
  uploadedexistFiles,
  uploadedFiles,
  setUploadedFiles,
  brandid,
  setIsloading,
  brandstatus,
}) => {
  const [uploadedOldFiles, setUploadedOldFiles] = useState([]);

  useEffect(() => {
    if (uploadedexistFiles && uploadedexistFiles.length > 0) {
      setUploadedOldFiles(uploadedexistFiles);
    }
  }, [uploadedexistFiles]);
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const existingNames = [
      ...uploadedOldFiles.map((f) => f.file_name),
      ...uploadedFiles.map((f) => f.name),
    ];

    const validFiles = files.filter((file) => {
      if (file.type !== "application/pdf") {
        alert("Only PDF files are allowed");
        return false;
      }
      if (file.size > UIConstant.max_brand_proof_pdfsize * 1024 * 1024) {
        alert(`File size must be less than ${UIConstant.max_brand_proof_pdfsize} MB`);
        return false;
      }
      if (existingNames.includes(file.name)) {
        alert(`File "${file.name}" is already uploaded`);
        return false;
      }
      return true;
    });

    // Check combined count of old files + existing uploaded files + new files
    const totalFilesCount =
      uploadedOldFiles.length + uploadedFiles.length + validFiles.length;

    if (totalFilesCount > UIConstant.max_brand_proof_pdfcount) {
      alert(`Maximum of ${UIConstant.max_brand_proof_pdfcount} files can be uploaded in total`);
      return;
    }

    const newFiles = validFiles.map((file) => ({
      name: file.name,
      size: (file.size / (1024 * 1024)).toFixed(2) + " MB",
      file: file,
    }));

    setUploadedFiles([...uploadedFiles, ...newFiles]);
    e.target.value = "";
  };

  const handleDeleteFile = (index) => {
    const newFiles = uploadedFiles.filter((_, i) => i !== index);
    setUploadedFiles(newFiles);
  };

  const handleDeleteOldFile = (index, fileid) => {
    const newFiles = uploadedOldFiles.filter((_, i) => i !== index);
    setUploadedOldFiles(newFiles);

    // Get current deletepdfs array or initialize as empty array
    const currentDeletePdfs = watch("deletepdfs") || [];

    // Add the fileid to the deletepdfs array
    const updatedDeletePdfs = [...currentDeletePdfs, fileid];

    // Set the value in the form
    setValue("deletepdfs", updatedDeletePdfs, { shouldDirty: true });

    console.log("Deleted old file with ID:", fileid);
    console.log("Updated deletepdfs array:", updatedDeletePdfs);
  };

  const handleDownloadFile = (file) => {
    const url = URL.createObjectURL(file.file);
    const a = document.createElement("a");
    a.href = url;
    a.download = file.name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleDownloadOldFile = async (fileInfo) => {
    try {
      console.log("Downloading old file:", fileInfo.file_name);

      if (setIsloading) setIsloading(true);

      let apiResponse = await downloadBrandProofDoc(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        brandid,
        fileInfo.id,
      );

      if (setIsloading) setIsloading(false);

      if (apiResponse.status === 200) {
        let filename = fileInfo.file_name;
        // const contentDisposition = apiResponse.headers.get(
        //   "Content-Disposition",
        // );

        // if (contentDisposition) {
        //   const match = contentDisposition.match(/filename="?([^"]+)"?/);
        //   if (match && match[1]) {
        //     filename = match[1];
        //   }
        // }

        const fileUrl = URL.createObjectURL(await apiResponse.blob());
        const a = document.createElement("a");
        a.href = fileUrl;
        a.download = filename;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(fileUrl);
      } else {
        alert("Failed to download file. Please try again.");
      }
    } catch (error) {
      console.log("Error downloading file:", error);
      if (setIsloading) setIsloading(false);
      alert("Error downloading file. Please try again.");
    }
  };
  return (
    <>
      <div className="general-settings">Proof of Documents</div>
       {(brandstatus !== "Pending" && brandstatus !== "Approved" ) && (
      <div
        className="uploadOuter mt-3 w-100 sm-w-100 my-3"
        style={{ paddingLeft: "10px" }}
      >
        <span className="dragBox2 upload-content sm-w-100">
          <span>
            <img src={uploadIcon} className="upload-img" alt="Upload Icon" />
          </span>
          <span>Drag and Drop to upload Files</span>
          <small className="text-secondary mt-2">
            Maximum of {UIConstant.max_brand_proof_pdfcount} PDF files
            (Max file size: {UIConstant.max_brand_proof_pdfsize} MB) can be uploaded!
          </small>
          <input
            type="file"
            id="uploadFile"
            className="upload__img LOA"
            onChange={handleFileChange}
            multiple
            accept=".pdf"
          />
        </span>
      </div>
        )}
      <h6 style={{ paddingLeft: "10px" }}>Upload Documents</h6>
      <div className="listOfFiles pt-0">
        {uploadedOldFiles && uploadedOldFiles.length > 0 && (
          <div className="d-flex  align-items-center justify-content-center flex-column">
            {uploadedOldFiles.map((fileinfo, index) => (
              <div className="border p-2 px-3 mt-2 rounded bg-light w-100 d-flex align-items-center justify-content-between">
                <span>{fileinfo.file_name}</span>
                <div className="d-flex align-items-center gap-3">
                  <MDBIcon
                    fas
                    icon="download"
                    size="lg"
                    className="cursor-pointer text-primary"
                    title="Download"
                    onClick={() => handleDownloadOldFile(fileinfo)}
                  />
                  {(brandstatus !== "Pending" && brandstatus !== "Approved" ) && (
                  <div style={{ width: "24px" }}>
                      <MDBIcon
                        fas
                        icon="trash-alt"
                        className="cursor-pointer text-danger"
                        size="lg"
                        title="Remove"
                        onClick={() =>
                          handleDeleteOldFile(index, fileinfo.id)
                        }
                      />
                    
                  </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
        {uploadedFiles.length > 0 && (
          <div className="d-flex  align-items-center justify-content-center flex-column">
            {uploadedFiles.map((fileinfo, index) => (
              <div className="border p-2 px-3 mt-2 rounded bg-light w-100 d-flex align-items-center justify-content-between">
                <span className="d-block">{fileinfo.name}</span>

                <div className="d-flex align-items-center gap-3">
                  {/* <MDBIcon
                    fas
                    icon="download"
                    size="lg"
                    className="cursor-pointer text-primary"
                    title="Download"
                    onClick={() => handleDownloadFile(fileinfo)}
                  /> */}
                  <div style={{ width: "24px" }}>
                      <MDBIcon
                        fas
                        icon="trash-alt"
                        size="lg"
                        className="cursor-pointer text-danger"
                        title="Remove"
                        onClick={() => handleDeleteFile(index)}
                      />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default ProofDocuments;
